var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyInvestIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.529,
    height: 26.193,
    viewBox: "0 0 25.529 26.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "why-invest-icon-3",
    d: "M28.736,16H42.33a.821.821,0,0,1,.821.819v8.742a9.4,9.4,0,0,1-7.618,9.2,9.4,9.4,0,0,1-7.618-9.2V16.819A.821.821,0,0,1,28.736,16Zm15.729,3.25H47.6a.656.656,0,0,1,.657.655c0,.012,0,.023,0,.035.087,2.8.116,4.98-.685,6.69a6.021,6.021,0,0,1-3.98,3.145,10.625,10.625,0,0,0,.55-1.614,4.282,4.282,0,0,0,2.244-2.083c.623-1.33.644-3.169.579-5.518h-2.5V19.25ZM26.6,20.559H24.1c-.065,2.349-.044,4.187.579,5.518a4.282,4.282,0,0,0,2.244,2.083,10.609,10.609,0,0,0,.55,1.614,6.022,6.022,0,0,1-3.98-3.145c-.8-1.71-.772-3.885-.685-6.69,0-.012,0-.023,0-.035a.656.656,0,0,1,.657-.655H26.6v1.31Zm15.04,19.827.043,0a.272.272,0,0,1,.246.271V41.92a.274.274,0,0,1-.274.273H29.409a.274.274,0,0,1-.274-.273V40.662a.272.272,0,0,1,.246-.271l.043,0a5.247,5.247,0,0,0,4.691-4.636,10.707,10.707,0,0,0,1.17.294l.249.048.249-.048a10.7,10.7,0,0,0,1.169-.294,5.247,5.247,0,0,0,4.691,4.636ZM35.95,20.345a.443.443,0,0,0-.833,0l-.8,2.212a.17.17,0,0,1-.158.114l-2.357.074a.441.441,0,0,0-.257.79l1.863,1.441a.17.17,0,0,1,.06.185l-.658,2.258a.442.442,0,0,0,.674.488l1.95-1.321a.171.171,0,0,1,.195,0l1.95,1.321a.442.442,0,0,0,.674-.488L37.6,25.161a.17.17,0,0,1,.06-.185l1.863-1.441a.441.441,0,0,0-.258-.79l-2.357-.074a.17.17,0,0,1-.158-.114Z",
    transform: "translate(-22.768 -16)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyInvestIcon3);
export default __webpack_public_path__ + "static/media/why-invest-icon-3.30732e2b181470c50f78ac0961321759.svg";
export { ForwardRef as ReactComponent };